/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import {
  TableCellValue,
  TableColumn,
  TableRow,
} from "../../../../../../requests/table/types";
import { ValueFormat } from "../../../../../../requests/templates/types";
import { Cell, multipleLinesCss } from "./styles";
import { FlowioTableCellInput } from "../../../../../atoms/inputs/FlowioInput";
import { BOLD } from "../../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";

const ValueCell: FC<Props> = ({
  column,
  row,
  format,
  editMode,
  onInputChange,
  onInputBlur,
  tableRowCallback,
}) => {
  const { columnAlias, editable } = column;

  const { templateId } = row;

  const cell = row.cells[columnAlias];
  const { value, unformattedValue } = cell;

  const { textAlign } = format.general;

  const isDisabled = !(editMode && editable);

  return (
    <Cell textAlign={textAlign} fontWeight={BOLD}>
      <FlowioTableCellInput
        value={value}
        unformattedValue={unformattedValue}
        column={column}
        format={format}
        templateId={Number(templateId)}
        onChange={onInputChange}
        onBlur={onInputBlur}
        editable={!isDisabled}
        css={isDisabled && multipleLinesCss}
        row={row}
        refetchRowCallback={tableRowCallback}
      />
    </Cell>
  );
};

type Props = {
  row: TableRow;
  format: ValueFormat;
  column: TableColumn;
  editMode?: boolean;
  onInputChange?: (v: TableCellValue) => void;
  onInputBlur?(): void;
  tableRowCallback?(): void;
};

export default ValueCell;
export type ValueCellProps = Props;
